import { ChatSituations } from '../../../../../utils/fuctions/mapSituationChat';

export const spotStyle = (type) => {
  switch (type) {
    case ChatSituations.WAITING_IN_QUEUE:
      return {
        name: 'AGUARDANDO VAGA NA FILA',
        color: '#f0ad4e',
        icon: 'fas fa-clock',
        iconColor: 'white'
      };
    case ChatSituations.WAITING_FOR_ANSWER:
      return {
        name: 'AGUARDANDO RESPOSTA',
        color: '#5cb85c',
        icon: 'far fa-bell',
        iconColor: 'white'
      };
    case ChatSituations.IN_ATTENDANCE:
      return {
        name: 'EM ATENDIMENTO',
        color: '#5cb85c',
        icon: 'far fa-bell',
        iconColor: 'white'
      };
    case ChatSituations.TRANSFERRED:
      return {
        name: 'TRANSFERIDA',
        color: '#f7f7f7',
        icon: 'fas fa-external-link-alt',
        iconColor: '#999999'
      };
    case ChatSituations.OVERFLOW:
      return {
        name: 'TRANSBORDO',
        color: '#ffa83c',
        icon: 'fas fa-exchange-alt',
        iconColor: 'white'
      };
    case ChatSituations.MAX_TIME_IN_QUEUE:
      return {
        name: 'TEMPO MÁXIMO',
        color: '#4f84d9',
        icon: 'fas fa-hourglass-end',
        iconColor: 'white'
      };
    case ChatSituations.TO_ANSWER:
      return {
        name: 'ATENDIDA',
        color: '#5bc0de',
        icon: 'fas fa-sign-in-alt',
        iconColor: 'white'
      };
    case ChatSituations.HANGED_UP:
      return {
        name: 'ENCERRADA',
        color: '#d9534f',
        icon: 'fas fa-check',
        iconColor: 'white'
      };
    case ChatSituations.REDISTRIBUTED:
      return {
        name: 'REDISTRIBUÍDA',
        color: '#3674B5',
        icon: 'fas fa-random',
        iconColor: 'white'
      };
    case ChatSituations.NOT_ANSWERED:
      return {
        name: 'NÃO ATENDIDA',
        color: '#d9534f',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    case ChatSituations.ABANDONED:
      return {
        name: 'ABANDONADA',
        color: '#d9534f',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    case ChatSituations.OVERFLOW:
      return {
        name: 'TRANSBORDO',
        color: '#d9534f',
        icon: 'fas fa-exchange-alt',
        iconColor: 'white'
      };
    case 'chamada_telefonica':
      return {
        name: 'CHAMADA TELEFÔNICA',
        color: '#5bc0de',
        icon: 'fas fa-phone',
        iconColor: 'white'
      };

    default:
      return {
        name: 'INDEFINIDO ',
        color: '#f7f7f7',
        icon: 'fas fa-question',
        iconColor: '#999999'
      };
  }
};
